import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateClipsFromSubtitleSearchV1Request } from './create-clips-from-subtitle-search-v1-request';
import type { ICreateClipsFromSubtitleSearchV1Response } from './create-clips-from-subtitle-search-v1-response';
import { createClipsFromSubtitleSearchV1ResponseSchema } from './create-clips-from-subtitle-search-v1-response';

interface IRequest {
  challengeId: number;
  body: ICreateClipsFromSubtitleSearchV1Request;
}

export async function createClipsFromSubtitleSearchV1Api({
  challengeId,
  body,
}: IRequest): Promise<IValidatedResponse<ICreateClipsFromSubtitleSearchV1Response>> {
  return postRequest<ICreateClipsFromSubtitleSearchV1Response>({
    path: `/sys/challenges/v1/${challengeId}/clips/from-subtitle-search`,
    body,
    schema: createClipsFromSubtitleSearchV1ResponseSchema,
  });
}
